<template>
	<div>
		<div class="card-body">

			<h4 class="text-center">
				{{service}}
			</h4>

			<div class="list-group list-group-heading list-group-flush col-md-10 mx-auto mt-3">
				
				<list-group-item 
				:title="$t('account/bookings.Type')">
					{{type}}
				</list-group-item>

				<list-group-item 
				:title="$t('account/bookings.Customs type')">
					{{booking.customs_type || '-'}}
				</list-group-item>

				<list-group-item 
				:title="$t('account/bookings.Crossing place')">
					{{place}}
				</list-group-item>

			</div> <!-- /.list-group -->

		</div> <!-- /.card-body -->

		<div 
		v-if="services.length"
		class="card-footer">
			<h5>
				{{$t('account/bookings.Additionals services')}}
			</h5>

			<div class="list-group list-group-flush mt-é">
				
				<list-group-item 
				:key="'service-'+index"
				v-for="(service, index) in services">
					{{service}}
				</list-group-item>

			</div> <!-- /.list-group -->

		</div> <!-- /.card-footer -->
	</div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {

		computed: {

			...mapState({
				booking: state => state.booking
			}),

			...mapGetters('booking', [
				'service',
				'services',
				'place',
				'type'
			])

		}

	}
</script>